import apiClient from '@/services/api-client';
import { apiSuccessCheck } from '../util/utilities';
import { isEmpty } from 'lodash';

export default {
	async getPreferencesByLoanId(loanId) {
		try {
			const response = await apiClient().get(
				`/Preference/GetLoanPreferences?loanId=${loanId}`,
			);

			if (response && response.data) {
				// INFO: filtering out "Rate" alert type in search filter due to KEEP go live, may unhide at a later date - Story: B360-3943
				const filteredLoanPreferences = response.data.preferences.filter(
					(preference) => preference.type.desc !== 'Rate',
				);
				response.data.preferences = filteredLoanPreferences;
				return Promise.resolve(response.data);
			}
		} catch (error) {
			return Promise.reject(error);
		}
	},
	async getAllLoanTypes() {
		try {
			const { status, data } = await apiClient().get('/Loan/GetAllLoanTypes');
			if (!apiSuccessCheck(status)) {
				throw new Error('API call failed');
			}
			if (isEmpty(data)) {
				throw new Error('No data received');
			} else {
				return Promise.resolve(data);
			}
		} catch (error) {
			return Promise.reject(error);
		}
	},
	async getAllLoanPurposeTypes() {
		try {
			const { status, data } = await apiClient().get(
				'/Loan/GetAllLoanPurposeTypes',
			);
			if (!apiSuccessCheck(status)) {
				throw new Error('API call failed');
			}
			if (isEmpty(data)) {
				throw new Error('No data received');
			} else {
				return Promise.resolve(data);
			}
		} catch (error) {
			return Promise.reject(error);
		}
	},
	async getLeadLoansForId(leadId) {
		try {
			const response = await apiClient().post('/Loan/GetAllLeadLoans', leadId);
			if (response && response.data) {
				return Promise.resolve(response.data);
			}
		} catch (error) {
			return Promise.reject(error);
		}
	},
	async saveLoanDetails(payload) {
		try {
			const response = await apiClient().post('/Loan/SaveLoan', payload);
			if (response && response.data) {
				return Promise.resolve(response.data);
			}
		} catch (error) {
			return Promise.reject(error);
		}
	},
	async saveLoanPreferences(payload) {
		try {
			const response = await apiClient().post(
				'/Preference/SaveLoanPreferences',
				payload,
			);
			if (response && response.data) {
				return Promise.resolve(response.data);
			}
		} catch (error) {
			return Promise.reject(error);
		}
	},
	async sendLoanToBlink(payload) {
		try {
			const response = await apiClient().post('/Blink/SendLoan', payload);
			if (response.data.emailStatus === false) {
				return Promise.reject(
					'Something went wrong, please go to Blink+ to create an application for this contact.',
				);
			} else {
				return Promise.resolve(response.data);
			}
		} catch (error) {
			return Promise.reject(error);
		}
	},
	async deleteLoan(payload) {
		try {
			const response = await apiClient().post('/Loan/DeleteLoan', payload);
			if (response && response.data) {
				return Promise.resolve(response.data);
			}
		} catch (error) {
			return Promise.reject(error);
		}
	},
};
